export class StaticPhrases {
  static serverNotFoundError = "Sunuculara bağlanılamadı. Lütfen internet bağlantınızı kontrol edip tekrar deneyiniz.";
}
